const questionsList = [
    {
      name: "What should I do if I’m logged out or can’t access the app?",
      answer: "Please try logging in again using your credentials, and reset your password if needed. If the issue persists, contact us directly at sales@blackbullbiochar.com."
    },
    {
      name: "Can I update my delivery address or contact info?",
      answer: "Yes. Navigate to the 'My Biochar' page, where you can update your delivery and billing information. For urgent delivery changes, please contact us directly at sales@blackbullbiochar.com."
    },
    {
      name: "How do I add a new field or zone to my account?",
      answer: "Go to the 'Biochar Plan' tab, then tap 'Add New Zone'. You can either drop a marker or draw your field directly on the map, then fill in the details like your land registry field number, field type, and area."
    },
    {
      name: "How do I create a new biochar application plan?",
      answer: "Head to 'Plans', tap 'Add New Plan', then select the zones you want to include. You’ll be able to enter your target rates and get a full breakdown of application rates to each field before saving the plan."
    },
    {
      name: "How is my recommended application rate calculated?",
      answer: "This is based on the application rates used in our field trials: 500 kg/ha for grassland and 1000 kg/ha for arable land. See the latest results from the trials at https://www.blackbullbiochar.com/biochar-field-trials."
    },
    {
      name: "What do the different plan colours on the map mean?",
      answer: "Zones in a selected plan are shaded from orange to green based on how close your biochar application is to the target rate. Grey zones are not part of the plan."
    },
    {
      name: "What is the difference between a zone and a field?",
      answer: "A zone is a management unit within a field, used to track applications more precisely. You can assign multiple zones to the same field if needed."
    },
    {
      name: "How do I report a problem or suggest a feature?",
      answer: "We’d love to hear from you. Use the contact form on the support page, or email us directly. Your input helps improve the app for all our customers."
    },
    
  ];
  
  export default questionsList;